// extracted by mini-css-extract-plugin
export default {"loading-spinner":"LoadingComponent_loading-spinner__ZaXxw"};